// extracted by mini-css-extract-plugin
export var quillEditor = "_jn-1";
export var variable = "_jn-0";